import React from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import SignIn from '../../components/SignIn';

const SignInPage = () => {
  return (
    <>  
      <LogoutHeader />
      <main>
        <SignIn />
      </main>
      <LogoutFooter />
    </>
  );
}

export default SignInPage;